// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"3eec3a6b","290":"d249252e","318":"2859e3c9","346":"70d95a47","453":"c5a6b037","531":"1514f75b","667":"0bc3b792","687":"d647f95c","750":"878b5223","832":"1ccca820","841":"5a69a63d","880":"17277ebf","974":"fd386629"}[chunkId] + ".chunk.js";
};